import React, { useState } from 'react';
import './solutions.scss';
import { useParams } from 'react-router-dom';
import Typing from 'react-typing-animation'
import Zoom from 'react-reveal/Zoom';
import Flip from 'react-reveal/Flip';
import Flash from 'react-reveal/Flash';
import { MathComponent } from 'mathjax-react'
import MathJax from 'react-mathjax';
import { CopyBlock, dracula } from "react-code-blocks";
import { problem_2a, problem_2b, TopBar } from "../../snippets";

const Two = (props) => {
    const [language, changeLanguage] = useState("JavaScript");
    const [language_b, changeLanguage_b] = useState("JavaScript");
    const [languageDemo, changeDemo] = useState(problem_2a["JavaScript"]);
    const [languageDemo_b, changeDemo_b] = useState(problem_2b["JavaScript"]);
    const [lineNumbers, toggleLineNumbers] = useState(false);
    const [process, setProcess] = useState(false);
    const [maxNum, setMaxNum] = useState(4000000);
    const [scaleProcess, setScaleProcess] = useState(false);
    const [maxNumScale, setMaxNumScale] = useState(4000000);

    //problem implementation logic
    const runProcess = (n) => {
        let a = 1, b = 1, sum = 0

        while (b < n){
            b = a + b
            a = b - a
            if (b % 2 == 0){
                sum += b
            }else {
                sum += 0
            }
        }
        return (sum)
    }

    const shoot = () =>{
        setProcess(true)
    }

    const runProcessScale = (n) =>{
      let sum = 0, term1 = 0, term2 = 2
      while (term2 < n) {
        sum = sum + term2
        term2 = 4*term2 + term1
        term1 = (term2-term1)/4
      }
      return (sum)
    }


    const shootScale = () =>{
      setScaleProcess(true)
    }
    return(
        <div>
            <p>
                The Fibonacci sequence is formally defined by the recurrence relation below:
                <MathComponent tex={String.raw`x_1 = 1, x_2 = 1, x_n = x_{n-1} + x_{n-2}`} />
            <br />
                This generates the below sequence:
            <br />
                <MathComponent tex={String.raw`1, 1, 2, 3, 5, 8, 13, 21, 34, 55, 89, 144,`} />
                <MathComponent tex={String.raw` 233, 377, 610, ...`} />

            <br />
            </p>
            <p>          
                To find the sum of even terms, we can check the terms' parity (odd or even) with a mod 2 conditional.
            </p>
            <div>
                  <Zoom left>
                    <TopBar
                      language={{
                        value: language,
                        onChange: e => {
                          changeDemo(problem_2a[e.target.value]);
                          return changeLanguage(e.target.value);
                        },
                        options: Object.keys(problem_2a).map(lang => (
                          <option key={lang} value={lang}>
                            {lang}
                          </option>
                        ))
                      }}
                      toggle={{
                        checked: lineNumbers,
                        onChange: e => toggleLineNumbers(!lineNumbers)
                      }}
                    />
                    <CopyBlock
                      language={language}
                      text={languageDemo}
                      showLineNumbers={lineNumbers}
                      theme={dracula}
                      wrapLines={true}
                      codeBlock
                    />   
                </Zoom>
              </div>
              <br />

              <div class="test-form">
                  <div class="my-form">
                    <h4 class="brand-title">Let's try it out</h4>
                    <div class="inputs">
                      <input 
                        type="number"
                        placeholder="Enter a maximum number" value={maxNum}
                        onChange={(e) => {
                          setMaxNum(e.target.value)
                          setProcess(false)
                        } 
                        }
                      />
                      <button type="submit"  onClick={shoot}>PROCESS</button>
                    </div>
                  </div>
              </div>

              <br />
              {process ? (
                  <p>
                      <Flip>
                        <div class="content-card" align="center">
                          <div class="card-big-shadow">
                              <div class="card card-just-text" data-background="color" data-color="blue" data-radius="none">
                                  <div class="card-content">
                                      <h4 class="description">Result</h4>
                                      <h5 class="title">                      <p>The sum of the even-valued terms in the Fibonacci sequence whose values do not exceed {maxNum} is <b id="value">{runProcess(maxNum)}</b></p></h5>                              
                                  </div>
                              </div>
                          </div>
                        </div>
                      </Flip>
                  </p>
              ) : (
                <p> <br /> </p>
              )}
              <br />

              <p>
                Robert McCann, University of Toronto (Bahen Centre) provided a good explanation on an easier way to find even Fibonacci multiples in one of his papers, Fibonacci mod k. Below is the summary of his theory.
                <br />
                Fibonacci terms below 800:
                <br />
                <MathComponent tex = {String.raw`1, 1, 2, 3, 5, 8, 13, 21, 34, 55, 89, 144, `} />
                <MathComponent tex = {String.raw`233, 377, 610`} />

                Even Fibonacci terms below 800:
                <MathComponent tex = {String.raw`0, 2, 8, 34, 144, 610`} />
                
                These follow the pattern:
                <MathComponent tex = {String.raw`x_0 = 0, x_1 = 2, x_n = 4*(x_{n-1}) + `} />
                <MathComponent tex = {String.raw`x_{n-2}`} />
              </p>
              <br />

              <div>
                  <Zoom>
                    <TopBar
                      language={{
                        value: language_b,
                        onChange: e => {
                          changeDemo_b(problem_2b[e.target.value]);
                          return changeLanguage_b(e.target.value);
                        },
                        options: Object.keys(problem_2b).map(lang => (
                          <option key={lang} value={lang}>
                            {lang}
                          </option>
                        ))
                      }}
                      toggle={{
                        checked: lineNumbers,
                        onChange: e => toggleLineNumbers(!lineNumbers)
                      }}
                    />
                    <CopyBlock
                      language={language_b}
                      text={languageDemo_b}
                      showLineNumbers={lineNumbers}
                      theme={dracula}
                      wrapLines={true}
                      codeBlock
                    />   
                
                </Zoom>
              </div>
              <br />
              <div class="test-form">
                <div class="my-form">
                  <h4 class="brand-title">Let's praticalize this</h4>
                    <div class="inputs">
                              <input 
                                type="number"
                                placeholder="Enter a maximum number" value={maxNumScale}
                                onChange={(e) => {
                                  setMaxNumScale(e.target.value)
                                  setScaleProcess(false)

                                  } 
                                }
                              />
                              <br />
                              <button type="submit"  onClick={shootScale}>PROCESS</button>
                              </div>
                                <br />
                              </div>
                            </div>
                            <div>
                            <br />
                            {scaleProcess ? (
                                <p>
                                  <Flash>
                                  <div class="content-card" align="center">
                                    <div class="card-big-shadow">
                                        <div class="card card-just-text" data-background="color" data-color="blue" data-radius="none">
                                            <div class="card-content">
                                              <h4 class="description">Result</h4>
                                                <h5 class="title">
                                                <p>The sum of the even-valued terms in the Fibonacci sequence whose values do not exceed {maxNumScale} is <b id="value2">{runProcessScale(maxNumScale)}</b></p>                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                  </div>
                                  </Flash>
                                </p>
                            ) : (
                              <p> <br /> </p>
                            )}
                            </div>
                          <br />
                          </div>
                   

    )
}
export default Two;